// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"30c85ff1","455":"f9d58f93","977":"9ba9b05b"}[chunkId] + ".chunk.js";
};